import { Video } from "@kalyzee/kast-web-sdk/web-components";
import React, { useMemo } from "react";
import { PlayerContainerRenderer } from "./interfaces";

export interface VideoPlayerProps {
  src: MediaStream;
  poster?: string;
  muted?: boolean;
  videoStyle?: React.CSSProperties;
  renderCustomContainer?: PlayerContainerRenderer;
}

const EMPTY_STYLE: React.CSSProperties = {};

export const VideoPlayer = React.memo(({ src, poster, muted, videoStyle, renderCustomContainer }: VideoPlayerProps) => {
  const mergedStyle = useMemo<React.CSSProperties>(
    () => ({ width: "100%", height: "100%", ...(videoStyle ?? EMPTY_STYLE) }),
    [videoStyle]
  );

  const renderContent = () => {
    return <Video poster={poster} muted={muted} style={mergedStyle} src={src} autoPlay playsInline />;
  };
  if (renderCustomContainer) {
    return <>{renderCustomContainer(renderContent())}</>;
  }
  return renderContent();
});
